/**
 * The Manager Assistant runs at the ROOT of its own domain (ma.ronidoc.ai, no
 * /pa prefix) and under /pa on the main domains (ronidoc.ai/pa). `pa()` builds
 * the right in-app route for the current host.
 *
 *   pa()           -> '/'        on ma,  '/pa'        elsewhere   (home/chat)
 *   pa('/voice')   -> '/voice'   on ma,  '/pa/voice'  elsewhere
 *   pa('/login')   -> '/login'   on ma,  '/pa/login'  elsewhere
 *
 * NOTE: this is for ROUTES only. API paths like '/pa/assistant' or
 * '/pa/briefing' are backend endpoints (served under /ma/*) and must stay literal.
 */
export const MA_HOST = typeof window !== 'undefined' && window.location.hostname === 'ma.ronidoc.ai';

const BASE = MA_HOST ? '' : '/pa';

export function pa(path = ''): string {
  const p = `${BASE}${path}`;
  return p === '' ? '/' : p;
}
